// extracted by mini-css-extract-plugin
export default {"SubscriptionDetailsWrapper":"subscription-details_SubscriptionDetailsWrapper__y2jfT","SubCard":"subscription-details_SubCard__w2vPD"};